import { Controller } from "stimulus";
import Cookies from "js-cookie";
import { EventDarkMode } from "../../events";
import { loadScript } from "../../util/load_script";

export default class extends Controller {
  static targets = ["tableRow", "imageFarmer", "description", "toggle", "title", "apyCalculatorWidget", "impermanentLossCalculatorWidget"];

  connect() {
    const changeDarkMode = this._changeDarkMode.bind(this);

    loadScript()
      .urls([
        "https://widgets.coingecko.com/coingecko-yield-farming-apy-widget.js",
        "https://widgets.coingecko.com/coingecko-yield-farming-impermanent-loss-calculator-widget.js"
      ]).then(() => {
        this._changeDarkMode();
      });

    window.addEventListener(EventDarkMode, changeDarkMode);

    $('#apy-calculator-modal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget)
      var apy = button.data('apy')
      var modal = $(this)
      modal.find('.modal-body coingecko-yield-farming-apy-widget').attr("initial-apy", apy)
    })
  }

  _changeDarkMode() {
    const IS_DARK = "is_dark";
    const isDark = Cookies.get(IS_DARK) === "true";
    if (isDark) {
      this.apyCalculatorWidgetTarget.setAttribute("background-color", "#252525");
      this.apyCalculatorWidgetTarget.setAttribute("font-color", "#ffffff");
      this.impermanentLossCalculatorWidgetTarget.setAttribute("background-color", "#252525");
      this.impermanentLossCalculatorWidgetTarget.setAttribute("font-color", "#ffffff");
    } else {
      this.apyCalculatorWidgetTarget.setAttribute("background-color", "#ffffff");
      this.apyCalculatorWidgetTarget.setAttribute("font-color", "#252525");
      this.impermanentLossCalculatorWidgetTarget.setAttribute("background-color", "#ffffff");
      this.impermanentLossCalculatorWidgetTarget.setAttribute("font-color", "#252525");
    }
  }
}
